import { createUpdateGroupConstants as gc } from 'srcReact/GroupPage'
import { objectMap, commonProperties } from 'srcReact/helpers/utils'

const initialState = {
  //genenal
  error: '',
  loading: false,
  privacySetting: '',
  groupCreation: {},
  workplaces: [],
  selectedWorkplace: {},
  groupName: null,
  groupType: '',
  description: null,
  location: null,
  formCompleted: false,
  formValidationErrors: [],
  groupInfo: null,
  selectedInterests: [],
  advanceSettings: {
    mixrSettings: {
      default: 1,
      userSelected: -1
    },
    memberSettings: {
      default: {
        age: 13
      },
      userSelected: null
    },
    admissionSettings: {
      default: 1,
      userSelected: -1
    }
  },
  //show next component states
  isGroupTypeVisible: false,
  isGroupNameVisible: false,
  isLocationVisible: false,
  isInterestsVisible: false,
  isPictureUploadVisible: false,
  isPrivacySettingsVisible: false,
  isDescriptionVisible: false,
  isAdvSettingsVisible: false,
  //groupPicture
  skipPicture: false,
  groupPicture: null,
  groupPictureError: null,
  loadingPicture: false,

  //on success
  createdGroupId: -1,
  createdGroupName: '',
  createdGroupUrl: '',
  editSuccess: false,

  //general group flag
  isGeneralGroup: false,
  createGroupErrors: [],
  updateGroupErrors: []
}

export function createUpdateGroup(state = initialState, action) {
  const { response } = action

  switch (action.type) {
    // select workplaces
    case gc.GET_WORKPLACES_REQUEST:
      return {
        ...state,
        loading: true
      }
    case gc.GET_WORKPLACES_SUCCESS:
      return {
        ...state,
        loading: false,
        groupCreation: { ...response.groupCreation },
        workplaces: [...response.workplaces]
      }
    case gc.GET_WORKPLACES_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    case gc.SET_SELECTED_WORKPLACE:
      return {
        ...state,
        selectedWorkplace: action.workplace
      }

    case gc.REMOVE_GROUP_PICTURE:
      return {
        ...state,
        groupPicture: null
      }

    case gc.SET_GROUP_PICTURE:
      return {
        ...state,
        groupPicture: action.picture
      }
    case gc.SET_SKIP_PICTURE:
      return {
        ...state,
        skipPicture: true,
        groupPicture: null
      }

    //create group
    case gc.CREATE_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        createGroupErrors: []
      }
    case gc.CREATE_GROUP_SUCCESS: {
      const { group } = action.response

      return {
        ...state,
        createdGroupId: group.id,
        createdGroupName: group.name,
        createdGroupUrl: group.url,
        loading: false,
        createGroupErrors: []
      }
    }
    case gc.CREATE_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        createGroupErrors: action.error
      }
    //setting name, description, location, privacy settings, advance settings
    case gc.SET_GROUP_NAME:
      return {
        ...state,
        groupName: action.groupName
      }

    case gc.SET_GROUP_TYPE:
      return {
        ...state,
        groupType: action.groupType
      }

    case gc.SET_GROUP_DESCRIPTION:
      return {
        ...state,
        description: action.description
      }
    case gc.SET_GROUP_LOCATION:
      return {
        ...state,
        location: action.location
      }
    case gc.SET_PRIVACY_SETTING:
      return {
        ...state,
        privacySetting: action.group
      }

    case gc.CAN_MEMBER_SUGGEST_MIXR: {
      return {
        ...state,
        advanceSettings: {
          ...state.advanceSettings,
          mixrSettings: { ...state.advanceSettings.mixrSettings, userSelected: action.canMemberSuggestMixr }
        }
      }
    }
    case gc.SET_MEMBER_SETTING: {
      return {
        ...state,
        advanceSettings: {
          ...state.advanceSettings,
          memberSettings: {
            ...state.advanceSettings.memberSettings,
            userSelected: { ...action.setting }
          }
        }
      }
    }
    case gc.SET_AUTO_APPROVAL_TO_JOIN: {
      return {
        ...state,
        advanceSettings: {
          ...state.advanceSettings,

          admissionSettings: {
            ...state.advanceSettings.admissionSettings,
            userSelected: action.autoApproveToJoin
          }
        }
      }
    }
    //show next component states
    case gc.SHOW_GROUP_TYPE:
      return {
        ...state,
        isGroupTypeVisible: true
      }
    case gc.SHOW_GROUP_NAME:
      return {
        ...state,
        isGroupNameVisible: true
      }
    case gc.SHOW_LOCATION:
      return {
        ...state,
        isLocationVisible: true
      }
    case gc.SHOW_INTERESTS:
      return {
        ...state,
        isInterestsVisible: true
      }
    case gc.SHOW_PICTURE_UPLOAD:
      return {
        ...state,
        isPictureUploadVisible: true
      }
    case gc.SHOW_DESCRIPTION:
      return {
        ...state,
        isDescriptionVisible: true
      }
    case gc.SHOW_PRIVACY_SETTING:
      return {
        ...state,
        isPrivacySettingsVisible: true
      }
    case gc.SHOW_ADV_SETTING:
      return {
        ...state,
        isAdvSettingsVisible: true
      }
    //form states
    case gc.SET_FORM_COMPLETED:
      return {
        ...state,
        formCompleted: true
      }
    case gc.SET_VALIDATION_ERRORS:
      return {
        ...state,
        formValidationErrors: action.validationErrors
      }
    case gc.CLEAR_ERRORS:
      return {
        ...state,
        formValidationErrors: []
      }
    case gc.SET_AS_GENERAL_GROUP:
      return {
        ...state,
        isGeneralGroup: true
      }
    case gc.CLEAR_DATA:
      return {
        ...initialState
      }
    case gc.GET_GROUP_DETAIL_REQUEST:
      return {
        ...state,
        loading: true
      }
    case gc.GET_GROUP_DETAIL_SUCCESS:
      const info = response && response.group
      return {
        ...state,
        loading: false,
        groupInfo: info
      }
    case gc.GET_GROUP_DETAIL_FAILURE:
      return {
        ...state,
        loading: false
      }

    //create group
    case gc.EDIT_GROUP_REQUEST:
      return {
        ...state,
        loading: true,
        editSuccess: false,
        updateGroupErrors: []
      }
    case gc.EDIT_GROUP_SUCCESS: {
      const { group } = action.response

      return {
        ...state,
        editSuccess: true,
        loading: false,
        groupInfo: group || state.groupInfo,
        updateGroupErrors: []
      }
    }
    case gc.EDIT_GROUP_FAILURE:
      return {
        ...state,
        loading: false,
        editSuccess: false,
        updateGroupErrors: action.error
      }
    case gc.SELECT_INTERESTS: {
      const interests = action.interestsArr
      return {
        ...state,
        selectedInterests: [...interests]
      }
    }
    default:
      return state
  }
}
